import React, { useState } from "react";
import ButtonComponent from "../generic/ButtonComponent";
import { syncVariantInventory } from "../../api/rest/ebay";
import { notify } from "../../helpers/notificationHelpers";
import { parseEbayError } from "../../utils/ebay";
import { SYNC_LISTING_CLICKED } from "../../constants/eventsTracked";

interface EbayResyncVariantButtonProps {
  integration: string;
  variantId: string | number;
}

function EbayResyncVariantButton(props: EbayResyncVariantButtonProps) {
  const { integration, variantId } = props;
  const [isResyncing, setIsResyncing] = useState(false);

  const handleResyncClick = () => {
    setIsResyncing(true);
    syncVariantInventory(variantId)
      .then(() => {
        notify.warn("Synchronizing inventory. This may take a few minutes");
      })
      .catch((error: Error) => {
        const message = parseEbayError(error);
        if (message) {
          notify.error(message);
        } else {
          notify.error(
            "Failed to synchronize inventory. Please try again later."
          );
        }
      })
      .finally(() => setIsResyncing(false));
  };

  if (integration !== "ebay") return null;

  return (
    <>
      <ButtonComponent
        primary
        compact
        disabled={isResyncing}
        onClick={() => handleResyncClick()}
        segmentEventName={SYNC_LISTING_CLICKED}
        segmentEventProperties={{ integration_type: integration }}
      >
        Sync
      </ButtonComponent>{" "}
    </>
  );
}

export default EbayResyncVariantButton;
